import { QueryClient } from '@tanstack/react-query'

export const USER_ALLOCATIONS_QUERY_KEY = 'sim-ops-user-allocations'

// esim queries used by UserProfileV3 / EsimStatusCardV3
export const refetchUserEsimQueries = (
  queryClient: QueryClient,
  userId: string
) => {
  queryClient.refetchQueries({
    queryKey: ['get-esim-by-userID-paginated', userId]
  })
  queryClient.refetchQueries({ queryKey: ['get-esim-by-userID', userId] })
  queryClient.refetchQueries({ queryKey: ['get-esim-status', userId] })
}

export const refetchUserAllocations = (
  queryClient: QueryClient,
  userId: string
) => {
  queryClient.refetchQueries({
    queryKey: [USER_ALLOCATIONS_QUERY_KEY, userId]
  })
}
